import { Stack } from "@mui/material";
import { TextBlock } from "./TextBlock";

export const NoticeList = ({
  text,
  borderColor = "#E5E5E5",
}: {
  text: string[];
  borderColor?: string;
}) => {
  if (!text || !Array.isArray(text)) return null;
  return (
    <Stack gap="24px">
      {text.map((el) => (
        <Stack
          paddingLeft="16px"
          key={el}
          borderLeft={`4px solid ${borderColor}`}
        >
          <TextBlock text={[el]} />
        </Stack>
      ))}
    </Stack>
  );
};
